<script>
import BaseInputPincode from '@/components/lavender/Input/Pincode.vue'
import ResendContainer from '@/containers/Resend/ResendContainer.vue'
import { formatPhoneNumber } from '@/utils/format'

export default {
  name: 'BodyContentInputOtp',
  components: {
    BaseInputPincode,
    ResendContainer,
  },
  props: {
    otp: {
      type: String,
      default: '',
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    submittingResend: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      required: true,
    },
    countryCallingCode: {
      type: String,
      required: true,
    },
  },
  emits: ['submit', 'resend', 'change:phone'],
  data() {
    return {
      errorMessages: {
        otp: '',
      },
    }
  },
  computed: {
    otpValue: {
      get() {
        return this.otp
      },
      set(value) {
        this.$emit('update:otp', value)
      },
    },
    shouldDisplayResend() {
      return true
    },
    phoneNumberFormatted() {
      return formatPhoneNumber(this.countryCallingCode, this.phoneNumber)
    },
  },
  methods: {
    validateOtp() {
      this.errorMessages.otp = ''

      if (!this.otp) {
        this.errorMessages.otp = this.$t('otp_required')

        return false
      }

      return true
    },
    handleSubmitOtp() {
      if (this.validateOtp()) {
        this.$emit('submit', { otp: this.otp })
      }
    },
    handleSubmitResend() {
      this.$emit('resend')
    },
  },
}
</script>

<template>
  <div class="verify-phone-number__body-content__input-otp">
    <div class="content-title">
      {{ $t('verify_phone_number_dialog_title') }}
    </div>
    <div class="content-description">
      {{ $t('verify_phone_number_dialog_description') }}
      <span dir="ltr" class="content-description__phone-number">
        {{ phoneNumberFormatted }}
      </span>
      {{ $t('verify_phone_number_dialog_description_2') }}
      <span
        class="content-description__change-phone"
        @click="$emit('change:phone')"
      >
        {{ $t('verify_phone_number_dialog_change_phone') }}
      </span>
    </div>
    <div class="content-input-field">
      <BaseInputPincode
        :model-value.sync="otpValue"
        :error-message="errorMessages.otp || errorMessage"
        :disabled="submitting"
        @complete="handleSubmitOtp"
      />
    </div>
    <ResendContainer
      :visible="shouldDisplayResend"
      :timeout="60"
      :disabled="submitting || submittingResend"
      class="mt-6"
      @resend="handleSubmitResend"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.verify-phone-number__body-content__input-otp {
  display: flex;
  flex-direction: column;

  .content-title {
    @extend .tamara-heading-large;

    color: var(--tamara-color-functional-grey-dark-2);
  }

  .content-description {
    @extend .tamara-paragraph-medium;

    margin-top: var(--tamara-spacing-xs);
    color: var(--tamara-color-text-secondary);

    &__change-phone {
      color: var(--tamara-color-accent-purple-dark);
      text-decoration: underline;
      text-underline-offset: 4px;
      cursor: pointer;
    }
  }

  .content-input-field {
    display: flex;
    justify-content: center;
    margin-top: var(--tamara-spacing-4xl);
  }

  .content-resend {
    &__wrapper {
      display: flex;
      flex-direction: column;
      margin-top: var(--tamara-spacing-xl);
    }

    &__body {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      margin-top: var(--tamara-spacing-xs);
    }
  }
}
</style>
